import React from 'react'
import {ConnectedRouter} from 'connected-react-router'
import {Switch, Route, Redirect, RouteProps} from 'react-router'
import {History} from 'history'
import LoginPage from '../pages/Login'
import ActionsPage from '../pages/Actions'
import ActionPage from '../pages/Action'
import {useSelector} from 'react-redux'
import {RootState} from 'src/redux/rootReducer'
import NavBar from 'src/components/NavBar'
import UsersPage from 'src/pages/Users'
import UserEdit from 'src/pages/UserEdit'
import UserCreate from 'src/pages/UserCreate'
import RoutinesPage from 'src/pages/Routines'
import RoutineCreate from 'src/pages/RoutineCreate'
import RoutineEdit from 'src/pages/RoutineEdit'
import LogoutPage from 'src/pages/Logout'
import MobilePage from 'src/pages/Mobile'

export type LoggedInProps = RouteProps & {
  loggedIn: boolean
}
const PrivateRoute: React.FC<LoggedInProps> = ({loggedIn, ...props}) => {
  if (loggedIn) {
    return <Route {...props} />
  }
  return <Redirect to="/login" />
}

const LoginRoute: React.FC<LoggedInProps> = ({loggedIn, ...props}) => {
  if (loggedIn) {
    return <Redirect to="/actions" />
  }
  return <Route {...props} />
}

type Props = {history: History}

const Navigation: React.FC<Props> = ({history}: Props) => {
  const {currentUser, dataState} = useSelector((state: RootState) => state.auth)
  const loggedIn =
    currentUser !== undefined &&
    currentUser.token !== undefined &&
    currentUser.isAdmin === true &&
    dataState.state === 'loaded'
  return (
    <ConnectedRouter history={history}>
      <NavBar loggedIn={loggedIn} history={history} />
      <Switch>
        <Route path="/mobile/routines/:id" component={MobilePage} />
        <Route path="/mobile/actions/:id" component={MobilePage} />
        <LoginRoute loggedIn={loggedIn} exact path="/login" children={<LoginPage />} />
        <PrivateRoute loggedIn={loggedIn} exact path="/logout" component={LogoutPage} />

        <PrivateRoute loggedIn={loggedIn} exact path="/actions" component={ActionsPage} />
        <PrivateRoute loggedIn={loggedIn} exact path="/actions/create" component={ActionPage} />
        <PrivateRoute loggedIn={loggedIn} exact path="/actions/:id" component={ActionPage} />

        <PrivateRoute loggedIn={loggedIn} exact path="/routines/" component={RoutinesPage} />
        <PrivateRoute loggedIn={loggedIn} exact path="/routines/create" component={RoutineCreate} />
        <PrivateRoute loggedIn={loggedIn} exact path="/routines/:id" component={RoutineEdit} />

        <PrivateRoute loggedIn={loggedIn} exact path="/users" component={UsersPage} />
        <PrivateRoute loggedIn={loggedIn} exact path="/users/create" component={UserCreate} />
        <PrivateRoute loggedIn={loggedIn} exact path="/users/:userID" component={UserEdit} />
        <PrivateRoute loggedIn={loggedIn} path="/">
          <Redirect to="/actions" />
        </PrivateRoute>
      </Switch>
    </ConnectedRouter>
  )
}

export default Navigation
